export const REGEX_CSS_NUMBER_VALUE: RegExp = /^\d+(\.[0-9]{1,4})?(px|em|rem|%)$/;
